// @noflow
import React from 'react';
import type { Node as React$Node } from 'react';
import { withTheme } from 'react-fela';
import PropTypes from 'prop-types';
import Box from './Box';
import type { BoxProps } from './Box';
import isReactNative from '../app/isReactNative';

// TODO: Implement auto jsx-a11y/img-has-alt.

type Size = {|
  exact?: boolean,
  height: number,
  width: number,
|};

type ImageProps = BoxProps & {
  size: Size,
  src: string | number, // number, because src={require('./foo.png')}
};

type ImageContext = {
  Image: () => React$Node,
};

const heightToNearestBaseline = (height, lineHeight) => {
  const baselineHeight1 = Math.floor(height / lineHeight) * lineHeight;
  const baselineHeight2 = Math.ceil(height / lineHeight) * lineHeight;
  const use1 = Math.abs(baselineHeight1 - height) < Math.abs(baselineHeight2 - height);
  return use1 ? baselineHeight1 : baselineHeight2;
};

const verticalRhythmSize = ({ exact, height, width }, lineHeight) => {
  if (exact) return { height, width, exactSize: true };
  const rhythmHeight = heightToNearestBaseline(height, lineHeight);
  return {
    height: rhythmHeight / lineHeight,
    width: (width * (rhythmHeight / height)) / lineHeight,
  };
};

const Image = (
  { size, src, theme, ...props }: ImageProps,
  { Image: PlatformImage }: ImageContext,
) => (
  <Box
    as={PlatformImage}
    {...verticalRhythmSize(size, theme.typography.lineHeight)}
    {...{ [isReactNative ? 'source' : 'src']: src }}
    {...props}
  />
);

Image.contextTypes = {
  Image: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  theme: PropTypes.object,
};

export default withTheme(Image, 'theme');
